import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/speed-gauge/speed-gauge.js';
      import {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {ObcSpeedGaugeNeedleType, SpeedAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/speed-gauge/speed-gauge.js';
import {TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';

      export interface Props {
     speed?: number;
     maxSpeed?: number;
     minSpeed?: number;
     showLabels?: boolean;
     tickmarksInside?: boolean;
     tickmarkInterval?: number | undefined;
     priority?: Priority;
     needleType?: ObcSpeedGaugeNeedleType;
     speedAdvices?: SpeedAdvice[];
     tickmarkStyle?: TickmarkStyle;
     showReadout?: boolean;
     setpoint?: number | undefined;
     newSetpoint?: number | undefined;
     atSetpoint?: boolean;
     touching?: boolean;
     autoAtSetpoint?: boolean;
     autoAtSetpointDeadband?: number;
     setpointAtZeroDeadband?: number;
     setpointOverride?: boolean;
     animateSetpoint?: boolean
   }

      
  
      export type {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {ObcSpeedGaugeNeedleType, SpeedAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/speed-gauge/speed-gauge.js';
export type {TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSpeedGauge',
  props: {
    speed: {},
    maxSpeed: {},
    minSpeed: {},
    showLabels: { type: Boolean },
    tickmarksInside: { type: Boolean },
    tickmarkInterval: {},
    priority: {},
    needleType: {},
    speedAdvices: {},
    tickmarkStyle: {},
    showReadout: { type: Boolean },
    setpoint: {},
    newSetpoint: {},
    atSetpoint: { type: Boolean },
    touching: { type: Boolean },
    autoAtSetpoint: { type: Boolean },
    autoAtSetpointDeadband: {},
    setpointAtZeroDeadband: {},
    setpointOverride: { type: Boolean },
    animateSetpoint: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-speed-gauge',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})